// extracted by mini-css-extract-plugin
export default {"Vertual":"Vertual_Vertual__imwpp","left":"Vertual_left__w+g72","wrapper":"Vertual_wrapper__6xdyW"};